var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VApp',[_c('v-main',{staticClass:"application"},[(this.$store.getters.isLoggedIn)?_c('SidBar'):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }